import Repository from '../Repository'

const resource = '/u/payments'
export default {
    fetch(){
        return Repository.get(`${resource}`) 
    },
    createPayment(params){
        return Repository.post(`${resource}`,params)
    },
    changePassword(params){
    }
}